// graph report
export const CampaignGraphReport = {
  // Campaign Media Demographic Stats
  GET_CAMPAIGN_MEDIA_DEMOGRAPHIC_STATS: "GET_CAMPAIGN_MEDIA_DEMOGRAPHIC_STATS",
  GET_CAMPAIGN_MEDIA_DEMOGRAPHIC_STATS_SUCCESS:
    "GET_CAMPAIGN_MEDIA_DEMOGRAPHIC_STATS_SUCCESS",
  GET_CAMPAIGN_MEDIA_DEMOGRAPHIC_STATS_FAILURE:
    "GET_CAMPAIGN_MEDIA_DEMOGRAPHIC_STATS_FAILURE",

  // download campaign graph PDF report
  DOWNLOAD_CAMPAIGN_GRAPH_PDF_REPORT: "DOWNLOAD_CAMPAIGN_GRAPH_PDF_REPORT",
  DOWNLOAD_CAMPAIGN_GRAPH_PDF_REPORT_SUCCESS:
    "DOWNLOAD_CAMPAIGN_GRAPH_PDF_REPORT_SUCCESS",
  DOWNLOAD_CAMPAIGN_GRAPH_PDF_REPORT_FAILURE:
    "DOWNLOAD_CAMPAIGN_GRAPH_PDF_REPORT_FAILURE",
  RESET_CAMPAIGN_GRAPH_PDF_REPORT: "RESET_CAMPAIGN_GRAPH_PDF_REPORT",

  // Download Campaign Graph Report Form
  OPEN_DOWNLOAD_CAMPAIGN_GRAPH_REPORT_MODAL:
    "OPEN_DOWNLOAD_CAMPAIGN_GRAPH_REPORT_MODAL",
  CLOSE_DOWNLOAD_CAMPAIGN_GRAPH_REPORT_MODAL:
    "CLOSE_DOWNLOAD_CAMPAIGN_GRAPH_REPORT_MODAL",

  // Campaign Graph Report Other Cities Info Form
  OPEN_CAMPAIGN_GRAPH_REPORT_OTHER_CITIES_INFO_MODAL:
    "OPEN_CAMPAIGN_GRAPH_REPORT_OTHER_CITIES_INFO_MODAL",
  CLOSE_CAMPAIGN_GRAPH_REPORT_OTHER_CITIES_INFO_MODAL:
    "CLOSE_CAMPAIGN_GRAPH_REPORT_OTHER_CITIES_INFO_MODAL",
};
